export enum HostType {
  DOMAIN = 'domain',
  APPID = 'appid'
}
